import { h } from "preact";

import i18n from "../../i18n.js";
import { displayEuro, incomeToK } from "../../salaryHelper.js";
import { classNames, renderHtml } from "../../helpers.js";
import { useLayoutEffect, useRef, useState } from "preact/hooks";

export default function SalaryComparison({
  type,
  inApp,
  result,
  showEstimate = true,
  ...props
}) {
  const ref = useRef();
  const [width, setWidth] = useState(null);

  const rangeMin =
    Math.floor((result.compensationRange[0] * 0.9) / 5000) * 5000;
  const rangeMax = Math.ceil((result.compensationRange[1] * 1.1) / 5000) * 5000;
  const rangeSpan = rangeMax - rangeMin;
  const rangeLeft = Math.round(
    Math.max(0, (100 * (result.compensationRange[0] - rangeMin)) / rangeSpan)
  );
  const rangeWidth =
    Math.round((100 * (result.compensationRange[1] - rangeMin)) / rangeSpan) -
    rangeLeft;
  const fromOverlaying = rangeLeft < 5;
  const toOverlaying = rangeLeft + rangeWidth > 95;
  const demandLeft = Math.round(
    Math.min(
      100,
      Math.max(0, (100 * (result.grossIncome - rangeMin)) / rangeSpan)
    )
  );

  useLayoutEffect(() => {
    setWidth(ref.current.getBoundingClientRect().width);
  }, []);

  return (
    <div ref={ref} class={props.class}>
      <p
        class={
          inApp ? "t-h6 color-brand-midnight" : "t-h5 color-brand-midnight"
        }
      >
        {i18n.t("pages.salary_calculator.result.comparison.title")}
      </p>
      <p
        class={classNames(
          "color-shades-charcoal mb-64",
          inApp ? "t-body3" : "t-body2"
        )}
      >
        {renderHtml(
          i18n.t("pages.salary_calculator.result.comparison.description", {
            jobTitle: result.workRole,
          })
        )}
      </p>
      <div class="salary-calculator-bar-chart">
        <div class="salary-calculator-bar-chart__min">
          {incomeToK(rangeMin).replace("€", "")}
        </div>
        <div class="salary-calculator-bar-chart__max">
          {incomeToK(rangeMax).replace("€", "")}
        </div>
        <div
          class="salary-calculator-bar-chart__range"
          style={`left: ${rangeLeft}%; width: ${rangeWidth}%;`}
        >
          <span class="salary-calculator-bar-chart__range-label">
            {i18n.t("pages.salary_calculator.result.salary_range")}
          </span>
          <div
            class={classNames(
              "salary-calculator-bar-chart__from",
              fromOverlaying && "salary-calculator-bar-chart__from--overlaying"
            )}
          >
            {incomeToK(result.compensationRange[0]).replace("€", "")}
          </div>
          <div
            class={classNames(
              "salary-calculator-bar-chart__to",
              toOverlaying && "salary-calculator-bar-chart__to--overlaying"
            )}
          >
            {incomeToK(result.compensationRange[1]).replace("€", "")}
          </div>
        </div>
        {showEstimate && (
          <div
            class={classNames(
              "salary-calculator-bar-chart__salary-demand",
              width - (width * demandLeft) / 100 < 160 &&
                "salary-calculator-bar-chart__salary-demand--right"
            )}
            style={`left: ${demandLeft}%`}
          >
            {i18n.t(`pages.${type}_calculator.result.salary_estimate`)}
            <br />
            <strong>{displayEuro(Math.round(result.grossIncome))}</strong>
          </div>
        )}
      </div>
    </div>
  );
}
